import {Directive, HostListener} from '@angular/core';
import {PassService} from './service/PassService';
@Directive({
    selector: '[appBlockCopyPaste]'
})
export class CopyPasteDirective {
    user: any;
    constructor(public pass: PassService) {}

    //  @HostListener('document:paste', ['$event']) blockPaste(e: KeyboardEvent) {
    //    e.preventDefault();
    //  }

    @HostListener('document:copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('document:cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('document:contextmenu', ['$event']) onRightClick(event) {
        console.log("event", event)
        event.preventDefault();
        alert("Right Click Is Disabled");
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(e: KeyboardEvent) {
        if (e.ctrlKey && e.keyCode == 80) {
            return false;
        } else if (e.ctrlKey && e.keyCode == 83) {
            return false;
        } else if (e.ctrlKey && e.ctrlKey && e.keyCode == 73) {
            return false;
        } else {
            return true;
        }
    }

}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/CopyPasteDirective.ts